//componets/Empresa/Listar-Empresa.js
import React, { useCallback, useState, useEffect } from 'react';

import Utils from "../../utilities/Utils";
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import EmpresaService from '../../service/EmpresaService';
import AuthorizationService from '../../service/AuthorizationService';

const empresaService = new EmpresaService(); // Create an instance of EmpresaService

const ListarEmpresa = () => {
    const [empresa, setEmpresa] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');

    const initEmpresa = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await empresaService.listAllEmpresas(iss);
            setEmpresa(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar empresas:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar empresas' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    const initFilters1 = () => {
        setFilters1({
            'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'cnpj': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    useEffect(() => {
        initFilters1();
        initEmpresa();
    }, [initEmpresa]);

    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postEmpresa'))
            history.push('/empresa/cadastrar');
    }

    const abreModalDeletar = (toDelete) => {
        setToDelete(toDelete);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (empresa) => {
        setToActive(empresa);
        setActiveDialog(true);
    }

    const handleDeleteTipo = () => {
        if (AuthorizationService.hasPermission('deleteEmpresa')) {
            setLoading1(true)
            empresaService.deleteEmpresa(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Empresa excluída com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initEmpresa();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar empresa' });
            }).finally(() => { setLoading1(false) });

        }
    }

    const handleActiveUsuario = () => {
        if (AuthorizationService.hasPermission('activeEmpresa')) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            empresaService.activeEmpresa(iss, toActive.id, status).then((data) => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Empresa ${status ? 'ativada' : 'inativada'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initEmpresa();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao ativar/destivar empresa' });
            }).finally(() => { setLoading1(false) });

        }
    }


    const editar = (tipoParaEditar) => {
        if (AuthorizationService.hasPermission('getEmpresa'))
            history.push('/empresa/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }


    const dataBody = (rowData, column) => {
        if (column.field === 'field_1' && rowData.document)
            if (rowData.document.length > 11) {
                return <span>{Utils.formatCnpj(rowData.document)}</span>
            } else {
                return <span>{Utils.formatCpf(rowData.document)}</span>
            }
        if (column.field === 'field_2' && rowData.telefone)
            return <span>{Utils.formatTelefone(rowData.telefone)}</span>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deleteEmpresa') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getEmpresa') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const statusBody = (rowData) => {
        return AuthorizationService.hasPermission('activeUser') ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postEmpresa') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Empresas</h5>
                    <DataTable value={empresa} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma empresa cadastrado.">
                        <Column sortable field="name" header="Nome Fantasia" filter filterPlaceholder="Procurar por prestador" style={{ minWidth: '12rem' }} />
                        <Column sortable body={dataBody} header="CPF/CNPJ" filter filterPlaceholder="Procurar por toDelete" style={{ minWidth: '12rem' }} />
                        <Column sortable field="categoriaCompany.nome" header="Categoria" filter filterPlaceholder="Procurar por categoria" style={{ minWidth: '10rem' }} />
                        <Column sortable field="cidade" header="Cidade" style={{ minWidth: '10rem' }} />
                        <Column sortable field="estado" header="Estado" style={{ minWidth: '3rem' }} />
                        <Column sortable field="ipagId" header="Cod. Ipag" style={{ minWidth: '6rem' }} />
                        <Column sortable field="ativo" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir a empresa selecionada?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o usuário selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarEmpresa, comparisonFn);
